// Export types individually to avoid conflicts
export type {
  User,
  EInvoiceBatchStatus,
  EInvoiceStatus,
  InvoiceTransactionType,
  BatchCreator,
  EInvoiceBatch,
  Patient,
  Invoice,
  ZatcaInvoiceData,
  EInvoiceSubmission,
  EInvoiceSubmissionUpdate,
  InvoiceGroup,
  EInvoiceBatchesProps,
  EInvoiceBatchDetailProps,
  BatchFilters,
  EInvoiceBatchesStats,
  RetryModalProps,
} from "./EInvoiceBatches.types";

import { lazy } from "@loadable/component";
import { Suspense } from "react";
import { ErrorBoundary } from "@sentry/react";
import { ErrorFallback } from "../../patterns";
import { EInvoiceBatchesProps, EInvoiceBatchDetailProps } from "./EInvoiceBatches.types";
import { EInvoiceBatchesLoading, EInvoiceBatchDetailLoading } from "./EInvoiceBatches.loading";

export const EInvoiceBatchesLoadable = lazy(
  () => import("./EInvoiceBatches")
);

export const EInvoiceBatchDetailLoadable = lazy(
  () => import("./EInvoiceBatchDetail")
);

export const EInvoiceBatches = (props: EInvoiceBatchesProps) => {
  return (
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Suspense fallback={<EInvoiceBatchesLoading />}>
        <EInvoiceBatchesLoadable {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};

export const EInvoiceBatchDetail = (props: EInvoiceBatchDetailProps) => {
  return (
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Suspense fallback={<EInvoiceBatchDetailLoading />}>
        <EInvoiceBatchDetailLoadable {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};





